import { create } from 'zustand'

interface ImageCacheStore {
  bustTimestamps: Record<string, number>
  bust: (autoid: string) => void
  getBustParam: (autoid: string) => number | undefined
}

export const useImageCacheStore = create<ImageCacheStore>()((set, get) => ({
  bustTimestamps: {},
  bust: (autoid) =>
    set((s) => ({ bustTimestamps: { ...s.bustTimestamps, [autoid]: Date.now() } })),
  getBustParam: (autoid) => get().bustTimestamps[autoid]
}))
